/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../api/types.generated";
export type GetDiscoveryProfileByUserQueryVariables = Types.Exact<{
  userId: Types.Scalars["Int"];
  eventSlug: Types.Scalars["String"];
}>;

export type GetDiscoveryProfileByUserQuery = {
  claims: Array<
    Pick<Types.Claim, "id"> & {
      stage: Pick<Types.Stage, "slug">;
      fields: Array<
        Pick<Types.FieldWithAnswer, "slug" | "field_type"> & {
          answer?: Types.Maybe<Pick<Types.FieldAnswer, "value">>;
        }
      >;
    }
  >;
};

export const GetDiscoveryProfileByUserDocument = gql`
  query GetDiscoveryProfileByUser($userId: Int!, $eventSlug: String!) {
    claims(
      take: 1
      orderBy: [{ created_at: desc }]
      where: {
        user_id: { equals: $userId }
        pipeline: {
          is: {
            event_slug: { equals: $eventSlug }
            type: { equals: "discovery-profiles" }
          }
        }
      }
    ) {
      id
      stage {
        slug
      }
      fields {
        slug
        field_type
        answer {
          value
        }
      }
    }
  }
`;

/**
 * __useGetDiscoveryProfileByUserQuery__
 *
 * To run a query within a React component, call `useGetDiscoveryProfileByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDiscoveryProfileByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDiscoveryProfileByUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      eventSlug: // value for 'eventSlug'
 *   },
 * });
 */
export function useGetDiscoveryProfileByUserQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetDiscoveryProfileByUserQuery,
    GetDiscoveryProfileByUserQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    GetDiscoveryProfileByUserQuery,
    GetDiscoveryProfileByUserQueryVariables
  >(GetDiscoveryProfileByUserDocument, baseOptions);
}
export function useGetDiscoveryProfileByUserLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetDiscoveryProfileByUserQuery,
    GetDiscoveryProfileByUserQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    GetDiscoveryProfileByUserQuery,
    GetDiscoveryProfileByUserQueryVariables
  >(GetDiscoveryProfileByUserDocument, baseOptions);
}
export type GetDiscoveryProfileByUserQueryHookResult = ReturnType<
  typeof useGetDiscoveryProfileByUserQuery
>;
export type GetDiscoveryProfileByUserLazyQueryHookResult = ReturnType<
  typeof useGetDiscoveryProfileByUserLazyQuery
>;
export type GetDiscoveryProfileByUserQueryResult =
  ApolloReactCommon.QueryResult<
    GetDiscoveryProfileByUserQuery,
    GetDiscoveryProfileByUserQueryVariables
  >;
